// ****************
// precoscrm.jsx
// autor: W de Paula
// data: 10/8/24 | 21h48
// proibida a reprodução, cópia, plágio ou uso para quaisquer fins, 
// sem autorização por escrito do autor. Sejeito às penalidas do rigor da lei.
// ****************





import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '@mdi/react';
import { mdiArrowLeftCircle } from '@mdi/js';

function PrecosCRM() {
    const ano = new Date().getFullYear();
    const ct = useLocation();
    const contrato = ct.state.contrato;
    const duracao = ct.state.duracao;
    const valor = ct.state.valor;

    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [formData, setFormData] = useState({
        nome: '',
        email: '',
        telefone: '',
        categoria: ''
    });
    const [errors, setErrors] = useState({});

    const handleBackClick = () => {
        navigate(-1); // Navegar para a página anterior
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [id]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [id]: '' })); // Limpa erros ao editar
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.nome) newErrors.nome = 'O campo Nome é obrigatório.';
        if (!formData.email) newErrors.email = 'O campo E-mail é obrigatório.';
        if (!formData.telefone) newErrors.telefone = 'O campo Telefone é obrigatório.';
        if (!formData.categoria) newErrors.categoria = 'O campo Ramo de Atividade é obrigatório.';
        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const newErrors = validateForm();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        // Se não houver erros, redireciona para o link mailto:
        window.location.href = mailtoLink;
    };

    // const handleWhatsAppClick = (e) => {
    //     const newErrors = validateForm();
    //     if (Object.keys(newErrors).length > 0) {
    //         setErrors(newErrors);
    //         e.preventDefault();
    //     }
    // };

    const handleWhatsAppClick = (e) => {
        e.preventDefault(); // Impede navegação imediata

        const newErrors = {};
        if (!formData.nome.trim()) newErrors.nome = 'Por favor, digite seu nome.';
        if (!formData.telefone.trim()) newErrors.telefone = 'WhatsApp é obrigatório.';
        if (!formData.categoria.trim()) newErrors.categoria = 'Informe sua categoria.';

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            // Rola até o primeiro erro
            const firstErrorField = Object.keys(newErrors)[0];
            document.getElementById(firstErrorField)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
        }

        // Se tudo OK, redireciona
        const whatsappURL = `https://wa.me/5531995525753?text=${whatsappMessage}`;
        window.open(whatsappURL, '_blank');
    };

    // Construir a mensagem personalizada para WhatsApp
    const whatsappMessage = encodeURIComponent(`
        Olá, gostaria de mais informações sobre o plano ${contrato}.\n
        Nome: ${formData.nome}\n
        Ramo de Atividade: ${formData.categoria}\n
    `);

    // Construir o link mailto para enviar o email
    const mailtoLink = `mailto:microvolution.informatica@gmail.com?subject=Interesse no Plano ${contrato}&body=Nome: ${formData.nome}%0D%0AE-mail: ${formData.email}%0D%0ATelefone: ${formData.telefone}%0D%0ARamo de Atividade: ${formData.categoria}%0D%0AContrato Escolhido: ${contrato}%0D%0ADuração: ${duracao}%0D%0AValor: ${valor}`;


    
    return (
        <section id="preco">
            <div className="container">
                <button className="btn btn-secondary back-button" onClick={handleBackClick}>
                    <Icon path={mdiArrowLeftCircle} size={1} /> {!isMobile && 'Voltar'}
                </button>
                <div className="row text-center">
                    <div className="titulo">
                        <h1>Planos e Preços</h1>
                        <p>Você escolheu a opção:</p>
                    </div>
                    <p>Duração: {duracao}</p>
                    <p>Valor: {valor}(*)</p>
                </div>
                <div className="form-container">
                    <br />
                    <h2 className='text-center'>Preencha seus dados</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="row mb-3">
                            <label htmlFor="nome" className="col-sm-2 col-form-label">Nome</label>
                            <div className="col-sm-10">
                                <input type="text" className="form-control" id="nome" placeholder="Seu Nome completo (**)" autoComplete="name" required onChange={handleChange} />
                                {errors.nome && <div className="text-danger">{errors.nome}</div>}
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="email" className="col-sm-2 col-form-label">E-mail</label>
                            <div className="col-sm-10">
                                <input type="email" className="form-control" id="email" placeholder="Seu melhor Email" autoComplete="email" required onChange={handleChange} />
                                {errors.email && <div className="text-danger">{errors.email}</div>}
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="telefone" className="col-sm-2 col-form-label">Telefone</label>
                            <div className="col-sm-10">
                                <input type="tel" className="form-control" id="telefone" placeholder="WhatsApp preferencial (**)" autoComplete="phone" required onChange={handleChange} />
                                {errors.telefone && <div className="text-danger">{errors.telefone}</div>}
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="categoria" className="col-sm-2 col-form-label">Ramo de atividade</label>
                            <div className="col-sm-10">
                                <input type="text" className="form-control" id="categoria" placeholder="Categoria do seu negócio (**)" autoComplete="category" required onChange={handleChange} />
                                {errors.categoria && <div className="text-danger">{errors.categoria}</div>}
                            </div>
                        </div>
                        {/* <div className='text-center'>
                            <button type="submit" className="btn btn-primary">Enviar Email</button>
                        </div> */}
                        
                        {/* // Substitua o botão "Enviar Email" por: */}
                        <div className="text-center mt-4">
                            <a
                                href="#"
                                onClick={handleWhatsAppClick}
                                className="btn btn-success btn-lg w-100 mb-3"
                                >
                                <i className="fab fa-whatsapp me-2"></i> Começar agora no WhatsApp
                            </a>
                            <p className="text-muted small">
                                <i className="bi bi-shield-check me-1"></i> Garantia de 7 dias: se não amar, devolvemos seu dinheiro.
                            </p>
                        </div>
                    </form>
                    <br />
                    <div className='nav col-md-4 justify-content-end list-unstyled d-flex text-center'>
                        <i className="bi bi-whatsapp mr-2"></i>
                        <p className="mr-2">Ou <a href={`https://wa.me/5531995525753?text=${whatsappMessage}`} target="_blank" rel="noopener noreferrer" onClick={handleWhatsAppClick}>fale conosco pelo WhatsApp</a></p>
                    </div>
                </div>
                <div className="row">
                    <label htmlFor="crmcondicoes">(*)Consulte condições</label>
                    <label htmlFor="crmcamposobrigatorios">(**)Campos obrigatórios</label>
                </div>
                <hr />
                <div>
                    <p className="h6">© {ano} Agendex. Todos os direitos reservados.</p>
                </div>
            </div>
        </section>
    );
}

export default PrecosCRM;